/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_No_Notes_FoundInputs */

const en_notes_no_notes_found = /** @type {(inputs: Notes_No_Notes_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes found`)
};

const es_notes_no_notes_found = /** @type {(inputs: Notes_No_Notes_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron notas`)
};

/**
* | output |
* | --- |
* | "No notes found" |
*
* @param {Notes_No_Notes_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_no_notes_found = /** @type {((inputs?: Notes_No_Notes_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_No_Notes_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_no_notes_found(inputs)
	return en_notes_no_notes_found(inputs)
});